import useGetMyAccountTeams from '@/api/queries/me/useGetMyAccountTeams';
import { usePermissions } from '@/hooks/usePermissions';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import { Combobox, SelectSizeVariant } from '@payaca/ambrosia';
import { FC } from 'react';
import { PermissionGuard } from '../../permissionGuard/PermissionGuard';
import { useListedTimelogsContext } from './listedTimelogsContext';

/**
 * Filters timelogs to the members of the selected team(s). Timelogs are only
 * ever assigned to individual users, so a team filter is really "everyone on
 * this team" — the context expands the selection to member user ids (unioned
 * with any individually-picked users) before querying.
 */
export const TeamFilter: FC = () => {
  const { selectedTeamIds, setSelectedTeamIds } = useListedTimelogsContext();

  const { userHasRequiredPermission } = usePermissions();
  const { data: accountTeams = [] } = useGetMyAccountTeams({
    enabled: userHasRequiredPermission([AccountsPermissions.GET_TEAMS]),
  });

  if (accountTeams.length === 0) return null;

  return (
    <PermissionGuard renderIfHasPermissions={[AccountsPermissions.GET_TEAMS]}>
      <div className="w-40">
        <Combobox
          multiple={true}
          sizeVariant={SelectSizeVariant.SM}
          placeholder="All teams"
          value={selectedTeamIds}
          onChange={setSelectedTeamIds}
          options={accountTeams.map((team) => ({
            label: team.name,
            value: team.id,
          }))}
        />
      </div>
    </PermissionGuard>
  );
};
